import { useNavigate, useOutlet } from 'react-router-dom';
import { Button, Divider, Group, Stack, Text, Title } from "@mantine/core";
import { ArrowLeft } from "tabler-icons-react";

import LoaderDefault from "../../components/common/Loader.default/Loader.default";
import ShipmentTable from "../../components/project/Shipment.table/Shipment.table";
import useShipmentQueryStore from "../../data/ShipmentQuery.store";
import { useShipments } from "../../api/Shipment/Shipment.hooks";

function ShipmentQueryResults() {
  const { shipmentQuery } = useShipmentQueryStore();
  let subTitle = '';

  if (shipmentQuery?.searchType === 'milestone') {
    subTitle = shipmentQuery.query?.dashboardMilestone;
  } else if (shipmentQuery?.searchType === 'quickTrack') {
    subTitle = shipmentQuery.query?.query;
  }

  const outlet = useOutlet();
  const { isLoading: shipmentsLoading, data: shipments } = useShipments(shipmentQuery);
  const navigate = useNavigate();

  if (outlet) {
    return outlet;
  }

  if (shipmentsLoading) {
    return <LoaderDefault text="Loading shipments data..." />
  }

  function onReferenceNumberClick(referenceNumber: string) {
    navigate(`/shipment-tracking/shipments/${referenceNumber}`)
  }

  return (
    <Stack>
      <Group position="apart">
        <Title order={3} style={{ color: "#C1C2C5" }}>
          {subTitle ? `Shipment Query Results - ${subTitle}` : 'Shipment Query Results'}
        </Title>
        <Button leftIcon={<ArrowLeft />} color="blue" onClick={() => navigate("/shipment-tracking")}>
          Back to Shipment Query
        </Button>
      </Group>
      <Divider />
      {shipments ?
        <ShipmentTable shipments={shipments} onReferenceNumberClick={onReferenceNumberClick} />
        :
        <Text color="white">No shipment data found.</Text>}
    </Stack>
  )
}

export default ShipmentQueryResults;